let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("inMW1")).then(() => parcelRequire('lqFfZ'));